export const getSpacing = (top?: boolean, right?: boolean, bottom?: boolean, left?: boolean, atomSpacing?: boolean) => {
  const classes: string[] = []

  if (left && right) {
    classes.push('container')
  } else {
    if (right) classes.push('right-spacing')
    if (left) classes.push('left-spacing')
  }

  if (atomSpacing) {
    if (top) classes.push('atom-top-spacing')
    if (bottom) classes.push('atom-bottom-spacing')
  } else {
    if (top) classes.push('top-spacing')
    if (bottom) classes.push('bottom-spacing')
  }

  return classes.join(' ')
}
